import React from 'react';

import EditableField from './EditableField';

import { groupResultFields } from './helpers/groupResultFields';
import formatKey from './helpers/formatKey';
import { IMPORT_DOCUMENT_FIELDS_GROUPS } from '../../constants/importDocuments';

function generateList(obj, depth, document, refetch, lenderId, parentKey = '') {
  const listItems = Object.keys(obj).map((key) => {
    const fullKey = parentKey ? `${parentKey}.${key}` : key;
    const isValueObject = typeof obj[key] === 'object' && obj[key] !== null;

    // Group keys should not be formatted
    const formattedKey = !Object.values(IMPORT_DOCUMENT_FIELDS_GROUPS).some(
      (group) => Object.keys(group).includes(key)
    )
      ? formatKey(key)
      : key;

    if (isValueObject) {
      return (
        <li key={key}>
          <span className="font-semibold">{formattedKey}</span>:{' '}
          {generateList(
            obj[key],
            depth + 1,
            document,
            refetch,
            lenderId,
            fullKey
          )}
        </li>
      );
    }

    return (
      <EditableField
        key={key}
        valueKey={key}
        value={obj[key]}
        formattedKey={formattedKey}
        document={document}
        fullKey={fullKey}
        refetch={refetch}
        lenderId={lenderId}
      />
    );
  });

  return (
    <ul className={`list-disc ${depth > 0 ? 'pl-8' : ''}`}>{listItems}</ul>
  );
}

export default function ParseurResultList({
  result,
  document,
  refetch,
  lenderId,
}) {
  const currentResult = groupResultFields(
    result,
    document.parseur_mailbox_description
  );

  return (
    <div>{generateList(currentResult, 0, document, refetch, lenderId)}</div>
  );
}
